import { useState } from "react";
import { ParticipanteRequest } from "../models/participantes";
import { Conyuge } from "../models/conyuge";
import { actualizarConyuge, deleteConyuge, getConyuge } from "../services/servicesConyuge";
import { AxiosResponse } from "axios";
import { StatusCode } from "../../../utils/enums";

export function useConyuge() {
    const [conyugeDefaultValues] = useState<Conyuge>({
        rut: '',
        apellidopaterno: '',
        apellidomaterno: '',
        nombres: '',
        fechanacimiento: new Date(),
        direccion: '',
        ciudadId: '',
        comunaId: '',
        profesion: '',
        sexo: '',
        estadocivil: '',
        nacionalidad: '',
        telefonoparticular: null,
        telefonocelular: null,
        telefonooficina: null,
        email: '',
        direccionCorrespondencia: '',
        ciudadCorrespondenciaId: '',
        comunaCorrespondenciaId: '',
    });

    const obtenerConyuge = async (dataRequest: ParticipanteRequest): Promise<Conyuge | void> => {

        const resp = await getConyuge(dataRequest)
        if (resp.status === StatusCode.Ok) {
            const dataConyuge: Conyuge = await resp.data;

            return dataConyuge;
        }
    }

    const eliminarConyuge = async (dataRequest: ParticipanteRequest) => {

        const resp: AxiosResponse = await deleteConyuge(dataRequest);
        return resp;

    }

    return {
        obtenerConyuge,
        conyugeDefaultValues,
        eliminarConyuge
    }
}

